import { useDatasetsQuery } from '../queries/useDatasetsQuery'
import { useFiltersStateContext } from '../state/useFiltersState'
import { useKeywordsStateContext } from '../state/useKeywordsState'

export const useFetchDatasets = () => {
  const selectedFiltersCount = useFiltersStateContext().getSelectedFiltersCount()
  const { submittedKeywords } = useKeywordsStateContext()
  const shouldFetchDefaultDatasets = !selectedFiltersCount && !submittedKeywords
  const { isFetching } = useDatasetsQuery(shouldFetchDefaultDatasets)

  return { isFetching }
}
